export const PICKUPS = Object.freeze({
    ORDER_TIMEOUT_BUFFER_MINS: 0,
    START_BUFFER_MINS: 60,
    END_BUFFER_MINS: 0,
    NEXT_TICK: 60,
    MINIMUM_PICKUP_TIME: 0,
} as const);
